const routingProvidersDataVersion = 1;

const routingProvidersData = [
  {
    id: 1,
    slug: 'graphhopper',
    title: 'GraphHopper',
    description: 'OSM-based routing and map matching via GraphHopper APIs.',
    active: true,
    priority: 1,
    requiresApiKey: true,
    config: {
      baseUrl: 'https://graphhopper.com/api/1',
      apiKey: '',
      profile: 'bike',
      profiles: [
        { value: 'bike', title: 'Bike', active: true },
        { value: 'foot', title: 'Foot / Hike', active: true },
        { value: 'car', title: 'Car', active: false }
      ],
      timeoutMs: 20000
    },
    docs: {
      keyUrl: 'https://www.graphhopper.com/sign-up/',
      pricingUrl: 'https://www.graphhopper.com/pricing/',
      restrictionsUrl: 'https://support.graphhopper.com/support/solutions/articles/44000718211-what-is-one-credit-',
      notes: 'Bring your own GraphHopper key. Free tier limits apply per account.'
    },
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 2,
    slug: 'openrouteservice',
    title: 'openrouteservice',
    description: 'OSM-based routing APIs by HeiGIT. Bring your own key.',
    active: false,
    priority: 2,
    requiresApiKey: true,
    config: {
      baseUrl: 'https://api.openrouteservice.org',
      apiKey: '',
      profile: 'cycling-regular',
      profiles: [
        { value: 'cycling-regular', title: 'Cycling', active: true },
        { value: 'foot-hiking', title: 'Hiking', active: true },
        { value: 'driving-car', title: 'Car', active: false }
      ],
      timeoutMs: 20000
    },
    docs: {
      keyUrl: 'https://openrouteservice.org/dev/#/signup',
      pricingUrl: 'https://openrouteservice.org/plans/',
      restrictionsUrl: 'https://openrouteservice.org/restrictions/',
      notes: 'Bring your own openrouteservice key. Quotas depend on the selected plan.'
    },
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 3,
    slug: 'osrm-compatible',
    title: 'OSRM-compatible Endpoint',
    description: 'Custom hosted OSRM endpoint (auth model depends on host).',
    active: false,
    priority: 3,
    requiresApiKey: false,
    config: {
      baseUrl: 'https://router.project-osrm.org',
      profile: 'bike',
      profiles: [
        { value: 'bike', title: 'Bike', active: true },
        { value: 'foot', title: 'Foot / Hike', active: true },
        { value: 'car', title: 'Car', active: false }
      ],
      timeoutMs: 20000,
      authMode: 'none'
    },
    docs: {
      keyUrl: 'https://github.com/Project-OSRM/osrm-backend',
      pricingUrl: 'https://map.project-osrm.org/about.html',
      restrictionsUrl: 'https://map.project-osrm.org/about.html',
      notes: 'OSRM itself has no native API-key product model. Key/auth may be required by your hosting provider.'
    },
    createdAt: Date.now(),
    updatedAt: null
  }
];

export { routingProvidersData, routingProvidersDataVersion };
